import { AzureAppRegistration } from '../../types/azureAppRegistration';

export const AZURE_APP_REGISTRATIONS_ANNOTATION = 'equinor.com/azure-apps';

// Matches entries like "my-app-dev/<guid>". Names may contain "/" since the entry is split on the
// trailing "/<guid>". Only GUIDs are accepted as id so annotation values cannot inject arbitrary
// content into the portal URL.
const APP_REGISTRATION_ENTRY_PATTERN =
  /^([^,]+?)\s*\/\s*([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i;

export function azureAppRegistrationsAnnotation(
  annotations: Record<string, string> | undefined,
): AzureAppRegistration[] {
  const raw = annotations?.[AZURE_APP_REGISTRATIONS_ANNOTATION];
  if (!raw) {
    return [];
  }

  return raw
    .split(',')
    .map(entry => APP_REGISTRATION_ENTRY_PATTERN.exec(entry.trim()))
    .filter((match): match is RegExpExecArray => match !== null)
    .map(([, name, id]) => ({
      name,
      id,
      overviewUrl: `https://portal.azure.com/#view/Microsoft_AAD_RegisteredApps/ApplicationMenuBlade/~/Overview/appId/${id}/isMSAApp~/false`,
    }));
}
